import { render, staticRenderFns } from "./TagBasic.vue?vue&type=template&id=5b0f8f64&"
import script from "./TagBasic.vue?vue&type=script&lang=js&"
export * from "./TagBasic.vue?vue&type=script&lang=js&"
import style0 from "./TagBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports